import { observer } from "mobx-react";
import React from "react";
import { RouteProps } from "react-router";
import { Redirect, Route } from "react-router-dom";
import { useStore } from "../../models";

interface Props extends RouteProps {
  redirectTo?: string;
}

/**
 * A component that will only mount / execute render if user is NOT authenticated.
 * Otherwise, it will redirect to the path specified in redirectTo prop or last path
 * set by PrivateRoute (if it rejects path due to user not being authenticated) .
 */
export const PublicRoute: React.SFC<Props> = observer(
  ({ redirectTo, render, component, ...rest }: Props) => {
    const { currentUserStore } = useStore();
    if (!(currentUserStore.loggedIn && currentUserStore.dataLoaded)) {
      return <Route {...rest} component={component} render={render} />;
    } else {
      return (
        <Route {...rest}>
          <Redirect to={{ pathname: redirectTo || currentUserStore!.loginRedirectPath }} />
        </Route>
      );
    }
  }
);
